import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/huasTadeHomeView.vue'
import StrategiesView from '../views/StrategiesView.vue'
import HuasTrade from '../views/huasTrade.vue'
//import { useAuthStore } from '@/store/auth'

const routes = [
  
   {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录',
      guestOnly: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: {
      title: '注册',
      guestOnly: true
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      title: '忘记密码',
      guestOnly: true
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      title: '重置密码',
      guestOnly: true
    }
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: () => import('@/views/VerifyEmail.vue'),
    meta: {
      title: '邮箱验证',
      guestOnly: true
    }
  },
  // 需要认证的路由
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      title: '仪表板',
      requiresAuth: true
    }
  },
  


  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
      title: '首页',
      guestOnly: true
    }
  },
  {
    path: '/Strategies',
    name: 'Strategies',
    component: StrategiesView
  },
  {
    path: '/HuasTrade',
    name: 'HuasTrade',
    component: HuasTrade,
    meta: {
      title: '交易页面',
      guestOnly: true
    }
  },
  {
    path: '/DataView',
    name: 'DataView',
    component: () => import('@/views/DataView'),
    meta: {
      title: '数据视图',
      guestOnly: true
    }
  },
  {
    path: '/strategiesViewsContainer',
    name: 'strategiesViewsContainer',
    component: () => import('@/views/strategy_list_view/StrategiesViewsContainer'),
    meta: {
      title: '策略视图容器',
      guestOnly: true
    }
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('@/views/CommunityView'),
    meta: {
      title: '社区',
      guestOnly: true
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/components/strat_board_highcharts/strat_grid_highchart'),
    meta: {
      title: '关于',
      guestOnly: true
    }
  },
  {
    path: '/strategyDetails',
    name: 'strategyDetails',
    component: () => import('@/views/strategy_list_view/StrategyDetailsPage'),
    meta: {
      title: '策略详情',
      guestOnly: true
    }
  },
  {
    path: '/strat_detail_amchart',
    name: 'strat_detail_amchart',
    component: () => import('@/components/strat_board_amcharts/strat_detail_amchart'),
    meta: {
      title: '策略详情 AMChart',
      guestOnly: true
    }
  },
  {
    path: '/strat_detail_amchart2',
    name: 'strat_detail_amchart2',
    component: () => import('@/components/strat_board_amcharts/strat_detail_amchart2'),
    meta: {
      title: '策略详情 AMChart 2',
      guestOnly: true
    }
  },
  {
    path: '/strategydetailsview',
    name: 'strategydetailsview',
    component: () => import('@/views/StrategyDetailsView'),
    meta: {
      title: '策略详情',
      guestOnly: true
    }
  },
  {
    path: '/TestTable',
    name: 'TestTable',
    component: () => import('@/views/TestTable')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// 路由守卫
// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore()
  
//   // 设置页面标题
//   if (to.meta.title) {
//     document.title = `${to.meta.title} - 我的应用`
//   }
  
//   // 检查是否需要认证
//   if (to.meta.requiresAuth && !authStore.isAuthenticated) {
//     next({
//       name: 'Login',
//       query: { redirect: to.fullPath }
//     })
//     return
//   }
  
//   // 检查是否只允许游客访问
//   if (to.meta.guestOnly && authStore.isAuthenticated) {
//     next({ name: 'Dashboard' })
//     return
//   }
  
//   next()
// })


export default router
